// extracted by mini-css-extract-plugin
export default {"container":"kq-z","brandName":"lq-z","productName":"mq-z","productNamePdpEnhancements":"nq-z","breakLongProductName":"oq-z"};